import React, { useEffect, useState } from "react";
import { Col, Row, Button } from "react-bootstrap";
import { Formik, Form, Field, FieldArray } from "formik";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import * as Yup from "yup";
import { CircularProgress } from "@material-ui/core";
// import { CardHeader } from "./../../../../_metronic/_partials/controls";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { getAllSystemSettingAsync, updateSystemSettingAsync } from "../redux";

const SystemSettingsForm = () => {
  const { systemSettingData, refreshSystemSettingdata } = useSelector(
    (state) => state.systemSettingManagement,
    shallowEqual
  );
  const dispatch = useDispatch();

  // Fetch system settings when the component mounts or refreshSystemSettingdata is triggered
  useEffect(() => {
    if (refreshSystemSettingdata) {
      dispatch(getAllSystemSettingAsync());
    }
  }, [refreshSystemSettingdata, dispatch]);

  // Form validation schema
  const editSystemSettingSchema = Yup.object().shape({
    settings: Yup.array().of(
      Yup.object().shape({
        value: Yup.string()
          .trim()
          .required("This field is required."),
      })
    ),
  });

  // Handle form submission to update only changed values
  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    setSubmitting(true);

    // Dispatch update for only changed settings
    values.settings.forEach((setting) => {
      if (setting.value !== setting.initialValue) {
        dispatch(
          updateSystemSettingAsync(
            setting._id,
            { value: setting.value },
            setSubmitting
            // resetForm
          )
        );
      }
    });
  };

  // Track if any value has changed
  const hasChanged = (settings) => {
    return settings.some((setting) => setting.value !== setting.initialValue);
  };

  return (
    <>
      <Row className="justify-content-center">
        <Col lg={12}>
          <Card>
            <CardHeader title="System Settings"></CardHeader>
            <CardBody>
              {/* Render the settings form with all settings as a list */}
              {systemSettingData?.data && (
                <Formik
                  initialValues={{
                    settings: systemSettingData.data.map((setting) => ({
                      _id: setting._id,
                      title: setting.title,
                      value: setting.value,
                      initialValue: setting.value, // Store initial value to compare later
                    })),
                  }}
                  validationSchema={editSystemSettingSchema}
                  onSubmit={handleSubmit}
                >
                  {({
                    values,
                    errors,
                    touched,
                    isSubmitting,
                    handleChange,
                    handleBlur,
                    setFieldValue,
                  }) => {
                    const isSaveButtonEnabled = hasChanged(values.settings);

                    return (
                      <Form>
                        <FieldArray
                          name="settings"
                          render={(arrayHelpers) => (
                            <>
                              {values.settings.map((setting, index) => (
                                <div key={setting._id} className="form-group">
                                  <label className="form-label text-white font-size-16px inter-font font-weight-normal">
                                    {setting.title}
                                  </label>

                                  <Field
                                    placeholder="Enter Value"
                                    name={`settings[${index}].value`}
                                    className={
                                      errors.settings?.[index]?.value &&
                                      touched.settings?.[index]?.value
                                        ? "form-control re_inputRouded is-invalid border-less-input"
                                        : "form-control re_inputRouded border-less-input"
                                    }
                                    onChange={(e) => {
                                      // Update the value on change
                                      setFieldValue(
                                        `settings[${index}].value`,
                                        e.target.value
                                      );
                                    }}
                                    onBlur={handleBlur}
                                    value={setting.value}
                                  />
                                  {touched.settings?.[index]?.value &&
                                    errors.settings?.[index]?.value && (
                                      <div className="fv-plugins-message-container">
                                        <div className="fv-help-block">
                                          {errors.settings[index].value}
                                        </div>
                                      </div>
                                    )}
                                </div>
                              ))}
                            </>
                          )}
                        />
                        {isSubmitting ? (
                          <div className="basic-verification-loader text-center">
                            <CircularProgress />
                          </div>
                        ) : (
                          <div className="text-left">
                            <Button
                              variant="blue"
                              className="px-5 defpddng btn btn-blue spinnerBtn add-avtar-btn d-flex justify-content-center"
                              size="lg"
                              type="submit"
                              disabled={!isSaveButtonEnabled || isSubmitting} // Disable if no change or submitting
                            >
                              Save
                            </Button>
                          </div>
                        )}
                      </Form>
                    );
                  }}
                </Formik>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default SystemSettingsForm;
